export default __webpack_public_path__ + "static/media/img (2).4a907526.jpg";